import React, { Fragment, useState, useEffect } from 'react'

import { Formik, Form } from 'formik';
import FormikFieldGroup from './shared/FormikFieldGroup'
import FormikPasswordField from './shared/FormikPasswordField'


import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link'
import classnames from 'classnames'

import MembershipOptions from './MembershipOptions'
import { useParams } from 'react-router-dom'
import { Typography } from '@material-ui/core';
import Questions from './Questions';
import { useDispatch, useSelector } from 'react-redux'
import { canRegister, signUp, signIn } from '../../store/actions/authenticationActions'

import { nonMemberAdd, notifyOrganizer } from '../../store/actions/membershipActions'
import { linkMemberAccount } from '../../store/actions/renewalEntryActions'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getSavedMemberInfo } from '../../store/actions/accountActions';


const styles = (theme) => ({
    padding2: {
        padding: theme.spacing(2)
    },
    padding3: {
        padding: theme.spacing(3)
    },
    playerContainer: {
        marginTop: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        backgroundColor: 'transparent'
    },
    smallText: {
        fontSize: theme.spacing(1.75)
    },
    center: {
        textAlign: 'center'
    },
    subText: {
        fontWeight: 500,
        paddingLeft: theme.spacing(2)
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    },
    header: {
        marginBottom: theme.spacing(3),
        fontWeight: 600
    },
    errorMessage: {
        color: theme.palette.error.main,
        height: '20px',
        marginTop: '-18px',
        fontSize: '12px',
        position: 'relative',
        right: 0,
        textAlign: 'right',
        background: 'white'
    },
    subHeader: {
        fontWeight: '600',
        color: '#444746'
    }

});



// Where an entry-link signup continues to, in the form's subheading.
const continueLabel = (path) => {
    if (path === '/renew') return 'your membership renewal'
    if (String(path || '').indexOf('/addon-renewal/') === 0) return 'your add-on renewal'
    return 'your account'
}

const RegisterComponent = ({ classes, resetFn, prefilledEmail, nextPath, onAuthenticated, onAccountExists }) => {
    const emailLocked = Boolean(prefilledEmail)
    // Entry-link signup (?type=signup&next=addon-renewal&...): an admin-managed
    // member who already has a member record and Stripe customer. No membership
    // picker, questions, payment or nonMember add: sign up, link the account to
    // the existing record by email, continue to nextPath.
    const entryLinkSignup = Boolean(nextPath)
    const [checkingAccount, setCheckingAccount] = useState(entryLinkSignup && emailLocked)
    const [submitError, setSubmitError] = useState('')

    const [questionsExist, setQuestionsExist] = useState(!entryLinkSignup)
    const [moreQues, setMoreQues] = useState(false)
    const [selectedReg, setSelectedReg] = useState()
    const [selectedRegMeta, setSelectedRegMeta] = useState(null)
    const membershipRegs = useSelector(state => state.memberships.regs);
    const [regTitle, setRegTitle] = useState('')
    const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    const PASSWORD_REGEX = /^\S.{4,28}\S$/
    const [registerFormValues, setRegisterFormValues] = useState({})
    const [canRegisterFlg, setCanRegister] = useState(true)
    const [isValidEmail, setIsValidEmail] = useState(false)
    const dispatch = useDispatch()
    const [noMemberSubmit, setNoMemberSubmit] = useState(false)
    const { memberId } = useParams()
    const [validMemberExist, setValidMemberExist] = useState(false);
    const [initValues, setInitValues] = useState({
        name: '',
        email: prefilledEmail || '',
        password: '',
    })

    useEffect(() => {
        if (prefilledEmail) {
            setInitValues(prev => ({ ...prev, email: prefilledEmail }))
        }
    }, [prefilledEmail])


    // Up front: the email in the link may have an account by now (spec section
    // 5). Then show the login form, not "email already exists".
    useEffect(() => {
        if (!entryLinkSignup || !prefilledEmail) {
            setCheckingAccount(false)
            return
        }
        setCheckingAccount(true)
        dispatch(canRegister(prefilledEmail, (err, canIRegister) => {
            setCheckingAccount(false)
            if (!err && canIRegister === false && onAccountExists) {
                onAccountExists()
            }
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entryLinkSignup, prefilledEmail])

    useEffect(() => {
        if (memberId) {
            console.log(memberId)
            dispatch(getSavedMemberInfo(memberId, (err, member) => {
                if (!err) {
                    setValidMemberExist(true);
                    setQuestionsExist(false)
                    setInitValues({
                        name: member.name,
                        email: member.email,
                        password: ''
                    })
                }
            }))
            // dispatch to fetch the corresponding email to prefill ! 
        }
    }, [memberId])

    const registerFn = (values) => {
        dispatch(signUp(values, (error) => {
            if (!error) {

                dispatch(signIn(values, (error, loginResponse) => {
                    if (!error) {
                        let messageInfo = {};
                        messageInfo.email = values.email;
                        messageInfo.name = values.name;
                        messageInfo.subject = values.name + ' registered to configure ACH payment';
                        messageInfo.message = 'Yay! New member signed up to configure ACH ';

                        dispatch(notifyOrganizer(messageInfo, () => { }))

                        dispatch(nonMemberAdd(loginResponse.loginToken, values.email, values.name, (error) => {
                            setNoMemberSubmit(false)
                            if (!error) {
                                window.location.reload()
                            }
                        }))
                    } else {
                        setNoMemberSubmit(false);

                    }
                })
                )
            } else {
                setNoMemberSubmit(false);
            }
        })
        )
    }

    const entryLinkRegisterFn = (values) => {
        const failed = (message) => {
            setSubmitError(message)
            setNoMemberSubmit(false)
        }

        dispatch(signUp(values, (error) => {
            if (error) {
                return failed('Your account could not be created, please try again.')
            }
            dispatch(signIn(values, (loginError, loginResponse) => {
                if (loginError || !loginResponse) {
                    return failed('Your account was created but you could not be signed in, please log in.')
                }
                dispatch(linkMemberAccount(loginResponse.loginToken, (linkError) => {
                    // Not fatal: the renewal API also finds the member by the
                    // account's email, and the renewal page reports access
                    // problems itself.
                    if (linkError) {
                        console.warn('linkMemberAccount failed', { status: linkError.status })
                    }
                    setNoMemberSubmit(false)
                    if (onAuthenticated) { onAuthenticated() }
                }))
            }))
        }))
    }

    const handleRegister = (values, {
        setFieldError
    }) => {
        setNoMemberSubmit(true);
        setSubmitError('')

        dispatch(canRegister(values.email, (err, canIRegister) => {
            if (entryLinkSignup) {
                if (err) {
                    setSubmitError('We could not check your email, please try again.')
                    setNoMemberSubmit(false)
                } else if (canIRegister) {
                    entryLinkRegisterFn(values)
                } else if (onAccountExists) {
                    setNoMemberSubmit(false)
                    onAccountExists()
                } else {
                    setCanRegister(false)
                    setNoMemberSubmit(false)
                }
                return
            }
            if (canIRegister) {
                console.log('Can Register')
                setCanRegister(true)
                if (questionsExist) {
                    setRegisterFormValues(values)
                    setMoreQues(true)

                } else {
                    registerFn(values);

                }
            } else {
                console.log("Cannot register")
                setCanRegister(false)
                setNoMemberSubmit(false);

            }
        }))


    }

    const validateEmail = (value) => {
        let isValid = false
        if(value && EMAIL_REGEX.test(value)){
            isValid = true
        } 
        setIsValidEmail(isValid)
        return isValid;
    }

    const canSignUpCheck = (value) => {

        if(validateEmail(value)){
            dispatch(canRegister(value, (err, canIRegister) => {
                setCanRegister(canIRegister)   
            }))
        }
        
    }

    const hideQuestions = () => {
        setMoreQues(false)
    }

    const resetToLogin = () => {
        //setQuestionsExist(false);
        resetFn();
    }


    const handleMembershipSelection = (e) => {

        if (e.target.value.toLowerCase() === 'no membership') {
            setQuestionsExist(false)
        } else {
            setSelectedReg(e.target.value.split('|')[0])
            setRegTitle(e.target.value.split('|')[1])
            setQuestionsExist(true)
            setSelectedRegMeta(membershipRegs.filter(reg => reg._id === e.target.value.split('|')[0])[0])
        }
    }
    const defaultValueCb = (defaultVal) => {
        setSelectedReg(defaultVal.split('|')[0])
        setRegTitle(defaultVal.split('|')[1])
        setQuestionsExist(true)
        setSelectedRegMeta(membershipRegs.filter(reg => reg._id === defaultVal.split('|')[0])[0])
    }
    const validate = values => {
        const errors = {}

        if (!values.name) {
            errors.name = 'Name is required'
        } else if (values.name.trim().length < 3) {
            errors.name = "The name should be at least 3 characters long."
        } else if (values.name.trim().length > 40) {
            errors.name = "The name should be 40 characters long at the most."
        }

        if (!values.email) {
            errors.email = "Email is required."
        } else if (!EMAIL_REGEX.test(values.email)) {
            errors.email = "Invalid email address."
        }

        if (!values.password) {
            errors.password = "Password is required."
        } else if (values.password.length < 6) {
            errors.password = "The password should be at least 6 characters long."
        } else if (values.password.length > 30) {
            errors.password = "The password should be 30 characters long at the most."
        } else if (!PASSWORD_REGEX.test(values.password)) {
            errors.password = "Leading and trailing white spaces are not allowed."
        }

        return errors
    }


    if (checkingAccount) {
        return <Grid container justify="center" className={classes.marginTop5}><CircularProgress /></Grid>
    }

    return <div style={{minWidth: '50%'}}>
        <Formik
            initialValues={initValues}
            enableReinitialize={true}
            onSubmit={handleRegister}
            validate={validate}
        >
            {!moreQues ? <Form>

                <Paper className={classnames(classes.marginTop1, classes.padding2, classes.bgTransparent)}>
                    <Grid container item direction="column" justify="center" alignItems="center" className={classes.header} >
                        <Typography variant="h5" className={classes.header}>Create an Account</Typography>
                        {validMemberExist && <Typography variant="body1"> You are almost there! Please create an account </Typography>}
                        {entryLinkSignup && <Typography variant="body1"> Create your account to continue to {continueLabel(nextPath)}. </Typography>}
                    </Grid>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Name </Grid>

                        <Grid item xs><Paper>  <FormikFieldGroup
                            label='Name'
                            name='name'
                            type='text'
                            placeholder='Please enter name'
                            elevation={2}
                            padding={12}
                        /></Paper></Grid>
                    </Grid>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Email Address</Grid>

                        <Grid item xs><Paper><FormikFieldGroup
                            label='Email'
                            name='email'
                            type='text'
                            placeholder='Please enter email'
                            elevation={2}
                            padding={12}
                            disabled={emailLocked}
                            /* Early "email already exists" check (new-member signup only;
                               entry-link signup checks up front and hands off to login). */
                            validate={entryLinkSignup ? undefined : canSignUpCheck}
                        />
                            {!canRegisterFlg && isValidEmail && <div className={classes.errorMessage}> This email already exists, please login to proceed.</div>}

                        </Paper>
                        </Grid>
                    </Grid>

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Password</Grid>

                        <Grid item xs><Paper><FormikPasswordField label={'password'} placeholder="Please enter password" /></Paper></Grid>
                    </Grid>
                    {!validMemberExist && !entryLinkSignup && <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Membership</Grid>

                        <Grid item>
                            <MembershipOptions handleChange={handleMembershipSelection} value={selectedReg} defaultValueCb={defaultValueCb}></MembershipOptions>
                        </Grid>

                    </Grid>}


                    {
                        !questionsExist ? <Fragment>
                            <Grid container className={classes.marginTop5} justify="flex-start">
                                <Grid item><Paper className={classnames(classes.bgTransparent, classes.smallText)} >By Creating your account you agree to <Link className={classes.link} href="https://register.tanglewoodresort.club/#/terms" target="_blank">Terms & Conditions</Link> </Paper></Grid>
                            </Grid>

                            <Grid container className={classes.marginTop2} justify="center">
                                <Grid item>
                                    <Button type="submit" variant="contained" disabled={noMemberSubmit} size="large" name="MakePaymentBtn" color="primary" className={classes.buttonPay} >
                                        Create Account
                                    </Button>
                                </Grid>
                            </Grid>
                            {submitError && <Grid container className={classes.marginTop2} justify="center">
                                <Typography variant="body2" color="error" role="alert">{submitError}</Typography>
                            </Grid>}
                        </Fragment> :
                            <Grid container className={classes.marginTop2} justify="center">
                                <Grid item>
                                    <Button type="submit" disabled={!canRegisterFlg} variant="contained" size="large" name="MakePaymentBtn" color="primary" className={classes.buttonPay} >
                                        Continue
                                    </Button>
                                </Grid>
                            </Grid>
                    }

                    <Grid container className={classes.marginTop5} justify="center">
                        <Grid item><Paper className={classnames(classes.bgTransparent, classes.smallText)} >Already have an account ? <Link className={classes.link} onClick={resetToLogin}> Login Here </Link> </Paper></Grid>
                    </Grid>

                </Paper>
            </Form> : <Questions registerFormValues={registerFormValues} regId={selectedReg} membershipRegs={membershipRegs} selectedRegMeta={selectedRegMeta} resetFn={hideQuestions} regTitle={regTitle} includeMemberInfo={true}></Questions>}

        </Formik>
    </div >

}


export default withStyles(styles)(RegisterComponent)